import React from 'react';
import UserChatHeader from '../UserChatHeader/UserChatHeader';
import TextEditor from '../../Editor/Editor';
import './inbox-announcement-view.scss';

const InboxAnnouncementView = ({ announcement, onSetAnnouncement }) => {
  return (
    <div className="inbox-announcement-view">
      <div className="header-row">
        <UserChatHeader
          title={
            (announcement.sendBy?.firstname || '') +
            ' ' +
            (announcement.sendBy?.lastname || '')
          }
          referenceType={''}
          description={announcement.sendBy?.role || ''}
          profileIcon={announcement.sendBy?.profileImage || ''}
          from="Announcement"
          onClickBack={() => onSetAnnouncement({})}
        />
      </div>
      <div className="announcement-scroll">
        <div className="announcement-heading">
          <h2>
            <img src="/assets/annoucement.png" />
            {announcement.title}
          </h2>{' '}
        </div>
        <TextEditor editorState={announcement.description} readOnly={true} />
      </div>
    </div>
  );
};

export default InboxAnnouncementView;